import Vue from 'vue'

import '@/element-ui'
import '@/utils/request'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/style/index.scss'
import '@/utils/clear-login' // 30min无操作退出登录

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
